import * as React from 'react';
import { SharedLegalPage } from './_shared/SharedLegalPage';
import { Documents } from '../../RoutesWidget';

export const SubProcessorsPage: React.FC = () => {
  return (
    <SharedLegalPage label="JourneyApps’ Sub-Processors" updated="March 13, 2023">
      <>
        <p>
          JourneyApps or its Affiliates may enlist the services of third-party providers, known as Sub-Processors, to
          assist in providing Services. This page provides the name, purpose and location for each Sub-Processor.
        </p>

        <h2>1. Infrastructure Sub-Processors</h2>
        <p>
          In order to enable JourneyApps to provide the Subscription Service, we use Sub-Processors as part of our
          infrastructure. By consenting to the <a href={Documents.GDPR_DPA}>Data Processing Addendum (DPA)</a>, you are
          acknowledging that all of the below Sub-Processors may be granted access to Customer Data.
        </p>

        <table>
          <tbody>
            <tr>
              <th>Entity Name</th>
              <th>Purpose</th>
              <th>Location</th>
            </tr>
            <tr>
              <td>Amazon Web Services, Inc.</td>
              <td>Cloud data hosting</td>
              <td>
                US, EU, AU
                <br />
                <span>*Location depends on application deployment settings.</span>
              </td>
            </tr>
            <tr>
              <td>MongoDB, Inc.</td>
              <td>Primary data hosting</td>
              <td>
                US, EU, AU
                <br />
                <span>*Location depends on application deployment settings.</span>
              </td>
            </tr>
            <tr>
              <td>Azure</td>
              <td>OpSQL data hosting</td>
              <td>
                EU
                <br />
                <span>*Location depends on OpSQL deployment settings.</span>
              </td>
            </tr>
            <tr>
              <td>SendGrid, Inc.</td>
              <td>Transactional email</td>
              <td>US</td>
            </tr>
          </tbody>
        </table>
        <h2>2. Feature Specific Sub-Processors</h2>
        <p>
          Certain features and integrations that we offer necessitate the involvement of additional Sub-Processors.
          Feature specific Sub-Processors will only apply if you opt-in. We will inform you in advance if you need to
          activate a feature or install an integration that requires the use of an opt-in Sub-Processor, as indicated in
          the table below.
        </p>

        <table>
          <tbody>
            <tr>
              <th>Entity Name</th>
              <th>Purpose</th>
              <th>Location</th>
            </tr>
            <tr>
              <td>Twilio, Inc.</td>
              <td>Outbound SMS notifications</td>
              <td>US</td>
            </tr>
            <tr>
              <td>Clickatell</td>
              <td>Outbound SMS notifications</td>
              <td>EU</td>
            </tr>
          </tbody>
        </table>
      </>
    </SharedLegalPage>
  );
};
